<div
	class="toolbar"
	[ngClass]="relatedFilesSelected ? 'related-files' : 'attached-files'"
>
	<div class="counter">
		{{ counterMessage }}
	</div>
	@if (relatedFilesSelected && !loadedSelection) {
		<div class="divider"></div>
	}

	@if (relatedFilesSelected && !loadedSelection) {
		<div
			class="upgrade-action"
			[class.disabled]="!relatedFilesSelected"
			matRipple
			(click)="link()"
		>
			<mat-icon
				[class.secondary-text-icon]="!relatedFilesSelected"
				[class.accent-icon]="relatedFilesSelected"
				svgIcon="attachment"
			></mat-icon>
			<span>{{ 'uploaded_to_asset' | translate }}</span>
		</div>
	}
	@if (!relatedFilesSelected) {
		<div class="divider"></div>
	}

	@if (!relatedFilesSelected) {
		<div class="delete-action" matRipple (click)="delete()">
			<mat-icon
				[class.secondary-text-icon]="relatedFilesSelected"
				[class.critical-icon]="!relatedFilesSelected"
				svgIcon="delete"
			></mat-icon>
			<span class="critical-icon">{{ 'delete' | translate }}</span>
		</div>
	}

	<div class="divider"></div>

	<div class="clear-action" matRipple (click)="clear()">{{ 'clear' | translate }}</div>
</div>
